module.exports = "https://cdn.dove.it/_next/static/public/assets/press/logo-hbritalia.d4ff771dff67ea0a7c488ff4b3ad2e42.png";